// Stored data decides the editor, never the landing-page URL or an item shape.
export const LIST_VERSION = 2;

export function resolveListType(metadata) {
  if (!metadata) return null;
  const { type, version } = metadata;
  if ((type == null || type === "bring") && (version == null || version === 1)) {
    return "bring";
  }
  if (["simple", "tasks", "participants"].includes(type) && version === LIST_VERSION) return type;
  return null;
}

export function createListRecord({ title, type = "bring" }) {
  const name = typeof title === "string" ? title.trim() : "";
  if (!name) throw new Error("A list title is required");
  if (type === "bring") return { title: name };
  if (["simple", "tasks", "participants"].includes(type))
    return { title: name, type, version: LIST_VERSION };
  throw new Error("Unsupported list type");
}

export function partitionEntries(entries) {
  const active = [];
  const archived = [];
  Object.entries(entries || {}).forEach(([id, entry]) => {
    if (!entry || typeof entry.what !== "string") return;
    (entry.archivedAt == null ? active : archived).push({ ...entry, id });
  });
  active.sort((a, b) => a.id.localeCompare(b.id));
  archived.sort((a, b) => b.archivedAt - a.archivedAt || a.id.localeCompare(b.id));
  return { active, archived };
}
